import React from 'react';
import {View} from 'MWComponents';
import PropTypes from 'prop-types';
import tpl from './templates/interactive.jsx';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INTERACTIVE
        };

        return this;
    }

    static displayName = 'GoogleTagManager';

    static propTypes = {
        gtmId: PropTypes.string.isRequired,
        dataLayerName: PropTypes.string,
        additionalEvents: PropTypes.object,
        previewVariables: PropTypes.string,
        scriptId: PropTypes.string
    };

    static contextTypes = {
        app: PropTypes.object
    };

    componentDidMount() {
        const dataLayerName = this.props.dataLayerName || 'dataLayer';
        const scriptId = this.props.scriptId || 'react-google-tag-manager-gtm';

        if (!window[dataLayerName]) {
            const gtmScriptNode = document.getElementById(scriptId);

            eval(gtmScriptNode.textContent);
        }
    }
}
